import slider from './slider';

slider();
